export default "__VITE_ASSET__B2kOG7tO__"